import { forwardRef } from 'react';

import { Radio, type RadioProps } from '../../atoms/Radio';
import { BaseFormField } from '../BaseFormField/BaseFormField';

export type Props = RadioProps & {
	label?: string;
};

export const RadioFormField = forwardRef<HTMLInputElement, Props>(({ label, ...radioProps }, ref) => {
	const { value, disabled, required } = radioProps;

	return (
		<BaseFormField
			label={label}
			value={value}
			isDisabled={disabled}
			isRequired={required}
			control={<Radio {...radioProps} ref={ref} />}
		/>
	);
});

RadioFormField.displayName = 'RadioFormField';
